import React from 'react';
import { Icon } from 'semantic-ui-react';

const LoadingComponent = (props) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingTop: 30 }}>
      <div>
        <h3 style={{ color: '#dedede' }}>{props.msg}</h3>
      </div>
      {props.children &&
        <div style={{ marginTop: 10 }}>
          {props.children}
        </div>
      }
      <div>
        <Icon size="huge" name='circle notched' loading />
      </div>
    </div>)
}

export default LoadingComponent;